/*
 *
 *  actions
 *
 */

import {
  LOAD_CLIENT_VISIT,
  LOAD_CLIENT_VISIT_SUCCESS,
  LOAD_CLIENT_VISIT_ERROR,
  LOAD_RECORDS_META_DATA,
  LOAD_RECORDS_META_DATA_SUCCESS,
  LOAD_RECORDS_META_DATA_ERROR,
  LOAD_BRANCH_CLIENT_VISIT,
  LOAD_BRANCH_CLIENT_VISIT_SUCCESS,
  LOAD_BRANCH_CLIENT_VISIT_ERROR,
  LOAD_COUNT,
  LOAD_COUNT_SUCCESS,
  LOAD_COUNT_ERROR,
  LOAD_BRANCH_COUNT,
  LOAD_BRANCH_COUNT_SUCCESS,
  LOAD_BRANCH_COUNT_ERROR,

} from "./constants"

export function loadRecordsCacheHit() {
  return {
    // type: LOAD_RECORDS_VALID_CACHE,ClientVisit
  }
}

export function loadClientVisit(searchFilter) {
  return {
    type: LOAD_CLIENT_VISIT,
    searchFilter,
  }
}

export function loadClientVisitSuccess(
  client_data,
  success
) {
  return {
    type: LOAD_CLIENT_VISIT_SUCCESS,
    client_data,
    success,
  }
}

export function loadClientVisitError(error) {
  return {
    type: LOAD_CLIENT_VISIT_ERROR,
    error,
  }
}
//BRANCH based filter api
//loadBranchClientVisit
export function loadBranchClientVisit(searchFilter) {
  return {
    type: LOAD_BRANCH_CLIENT_VISIT,
    searchFilter,
  }
}

export function  loadBranchClientVisitSuccess(
  branchClient_data,
  success
) {
  return {
    type: LOAD_BRANCH_CLIENT_VISIT_SUCCESS,
    branchClient_data,
    success,
  }
}

export function loadBranchClientVisitError(error) {
  return {
    type: LOAD_BRANCH_CLIENT_VISIT_ERROR,
    error,
  }
}
//count api
export function loadCount(countDetails) {
  return {
    type: LOAD_COUNT,
    countDetails,
  }
}

export function  loadCountSuccess(
  count_data,
  success
) {
  return {
    type: LOAD_COUNT_SUCCESS,
    count_data,
    success,
  }
}

export function loadCountError(error) {
  return {
    type: LOAD_COUNT_ERROR,
    error,
  }
}
//BRANCH BASED COUNT API //loadBranchCount
export function loadBranchCount(branchCountDetails) {
  return {
    type: LOAD_BRANCH_COUNT,
    branchCountDetails,
  }
}

export function  loadBranchCountSuccess(
  branchCount_data,
  success
) {
  return {
    type: LOAD_BRANCH_COUNT_SUCCESS,
    branchCount_data,
    success,
  }
}

export function loadBranchCountError(error) {
  return {
    type: LOAD_BRANCH_COUNT_ERROR,
    error,
  }
}
//
export function loadRecordsMetaData() {
  return {
    type: LOAD_RECORDS_META_DATA,
  }
}

/**
 *
 * @param {object} recordsMetaData
 * @returns
 */
export function loadRecordsMetaDataSuccess(recordsMetaData) {
  return {
    type: LOAD_RECORDS_META_DATA_SUCCESS,
    recordsMetaData,
  }
}

/**
 *
 * @param {string} error
 * @returns
 */
export function loadRecordsMetaDataError(error) {
  return {
    type: LOAD_RECORDS_META_DATA_ERROR,
    error,
  }
}

const actions = {
  loadClientVisit,
  loadClientVisitSuccess,
  loadClientVisitError,

  loadBranchClientVisit,
  loadBranchClientVisitSuccess,
  loadBranchClientVisitError,

  loadCount,
  loadCountSuccess,
  loadCountError,

  loadBranchCount,
  loadBranchCountSuccess,
  loadBranchCountError,

  loadRecordsCacheHit,
  loadRecordsMetaData,
  loadRecordsMetaDataSuccess,
  loadRecordsMetaDataError,
}

export default actions
